/* GENERATED — do not edit by hand.
 *
 *   node scripts/build-exhibitors.mjs "<the committee's exhibitor sheet>.csv"
 *
 * Source: the committee's exhibitor sheet. Only rows marked "Paid" or
 * "Confirmed not paid" appear here; leads and declines do not.
 *
 * Descriptions are curated in the BLURBS map inside that script, not here, so
 * re-running it against a newer export keeps them. Blank blurb = nothing
 * publishable yet; the card renders name and pavilion, which stands on its own.
 *
 * Sponsorship is deliberately absent. The sheet's Sponsors columns are empty on
 * every row, so there is nothing to show. When that data exists, add a `tier`
 * field here and the section will pick it up.
 */

export const EXHIBITORS = [
  {
    name: "53 Jewels",
    pavilion: "Retail & Consumer Goods",
  },
  {
    name: "Alwaan",
    pavilion: "Food & Hospitality",
    blurb: "A Chicago food business of twenty years' standing.",
  },
  {
    name: "AMAZ",
    pavilion: "Technology & Innovation",
    blurb: "Networking and cybersecurity services.",
  },
  {
    name: "BluPencil Consulting",
    pavilion: "Technology & Innovation",
    logo: "exhibitor-blupencil-consulting.jpg",
    url: "https://blupencilconsulting.com/",
  },
  {
    name: "Bohri & Associates",
    pavilion: "Professional Services",
  },
  {
    name: "Broad Peak Systems Inc",
    pavilion: "Technology & Innovation",
  },
  {
    name: "CIG Garment Manufacturing",
    pavilion: "Manufacturing",
    blurb: "Customised garment manufacturing — hoodies, sweatshirts, sweatpants, polo shirts — knitting its own fabric in Toronto.",
    logo: "exhibitor-cig-garment-manufacturing.png",
    url: "https://ciggarment.com/",
  },
  {
    name: "Crescent Consultants",
    pavilion: "Professional Services",
  },
  {
    name: "Cysora",
    pavilion: "Technology & Innovation",
    logo: "exhibitor-cysora.svg",
    logoDark: true,
    url: "https://www.cysora.com/",
  },
  {
    name: "Emrixtech Inc",
    pavilion: "Professional Services",
    url: "https://emrixtech.com/",
  },
  {
    name: "Ezzy Associates",
    pavilion: "Professional Services",
    logo: "exhibitor-ezzy-associates.svg",
    url: "https://www.ezzyassociates.com/",
  },
  {
    name: "Fakhri Business Solutions dba Detroit Digital Marketing",
    pavilion: "Creative Services",
    logo: "exhibitor-fakhri-business-solutions-dba-detroit-digital-marketing.png",
    url: "https://www.thedetroitdigital.com/",
  },
  {
    name: "Faya Jewels",
    pavilion: "Retail & Consumer Goods",
  },
  {
    name: "Floor Chem Inc",
    pavilion: "Manufacturing",
  },
  {
    name: "Greenback Holdings Inc.",
    pavilion: "Professional Services",
    blurb: "A business web app, launching soon.",
  },
  {
    name: "HarborTechAI",
    pavilion: "Technology & Innovation",
  },
  {
    name: "HAZWOPER OSHA Training",
    pavilion: "Professional Services",
  },
  {
    name: "Hilal Software Corporation",
    pavilion: "Technology & Innovation",
    blurb: "Business automation built on AI.",
  },
  {
    name: "iThink Solutions",
    pavilion: "Healthcare & Wellness",
  },
  {
    name: "Jamali Kitchen",
    pavilion: "Food & Hospitality",
  },
  {
    name: "Jamali Kopy Kat Printing",
    pavilion: "Retail & Consumer Goods",
    blurb: "A family-owned printing company in Bellwood, established in 1973 and serving businesses across the area for over fifty years.",
  },
  {
    name: "Kapasi’s Kupcakes",
    pavilion: "Food & Hospitality",
  },
  {
    name: "Kettle & Oak",
    pavilion: "Real Estate & Construction",
    logo: "exhibitor-kettle-oak.svg",
    url: "https://kettleandoak.com/",
  },
  {
    name: "Kings Bathroom and Kitchen",
    pavilion: "Manufacturing",
    blurb: "Full home renovation, and kitchen cabinets manufactured in house.",
  },
  {
    name: "LSS Sweet and Spicy",
    pavilion: "Food & Hospitality",
  },
  {
    name: "Maaeidaah Catering",
    pavilion: "Food & Hospitality",
  },
  {
    name: "Majma Cafe",
    pavilion: "Food & Hospitality",
    blurb: "A tea and fusion café in the making, bringing a few recipes to the floor.",
  },
  {
    name: "Melt N Dip",
    pavilion: "Food & Hospitality",
  },
  {
    name: "MH Handcrafted",
    pavilion: "Manufacturing",
    blurb: "Premium event fabrication and builds, specialising in brand activations and pop-ups.",
  },
  {
    name: "Mubarak Caterers",
    pavilion: "Food & Hospitality",
  },
  {
    name: "Nafees Consulting",
    pavilion: "Professional Services",
    blurb: "Recruitment across the industrial and corporate sectors, partnering with businesses throughout North America on sales, HR, finance, IT and administration hiring.",
  },
  {
    name: "Namaa Properties",
    pavilion: "Real Estate & Construction",
    logo: "exhibitor-namaa-properties.png",
    url: "https://www.namaaproperties.com/",
  },
  {
    name: "Nuqisoaps",
    pavilion: "Manufacturing",
    blurb: "All-natural, organic and vegan skin and hair care, made with herbs and suited to all ages and skin types.",
  },
  {
    name: "Quami Libas",
    pavilion: "Retail & Consumer Goods",
    blurb: "Men's and children's wear — kurta, saya suits, pehran, izar, topi, pheta, phagdi, masalla and rumals.",
  },
  {
    name: "Royal Cyber",
    pavilion: "Technology & Innovation",
    logo: "exhibitor-royal-cyber.svg",
    url: "https://www.royalcyber.com/",
  },
  {
    name: "SBS America",
    pavilion: "Real Estate & Construction",
    blurb: "A Mumineen investment fund bringing diversified options across asset classes to the community.",
    logo: "exhibitor-sbs-america.jpg",
    url: "https://sbsamerica.org/",
  },
  {
    name: "Scentivana",
    pavilion: "Manufacturing",
    blurb: "Perfume, attar and bakhoor.",
  },
  {
    name: "Shirin Marvi Real Estate",
    pavilion: "Real Estate & Construction",
    blurb: "Residential real estate.",
    logo: "exhibitor-shirin-marvi-real-estate.png",
    url: "https://www.shirinmarvi.com/",
  },
  {
    name: "Siraj Frames",
    pavilion: "Retail & Consumer Goods",
    blurb: "Framed photographs and canvases of Aqa Moula, exhibiting on behalf of a family business in India.",
  },
  {
    name: "Smooth Solutions Medspa",
    pavilion: "Healthcare & Wellness",
    url: "https://smoothsolutionsmedspa.com/",
  },
  {
    name: "SpotGenius",
    pavilion: "Technology & Innovation",
    logo: "exhibitor-spotgenius.png",
    url: "https://www.spotgenius.com/",
  },
  {
    name: "Stallion Builders, Inc",
    pavilion: "Real Estate & Construction",
    logo: "exhibitor-stallion-builders-inc.png",
    url: "https://www.stallion-builders.com/",
  },
  {
    name: "Sukoon Selection",
    pavilion: "Manufacturing",
    blurb: "Handcrafted jewellery.",
  },
  {
    name: "Surti Diamond Company",
    pavilion: "Retail & Consumer Goods",
  },
  {
    name: "The Premium Basket",
    pavilion: "Food & Hospitality",
    logo: "exhibitor-the-premium-basket.svg",
    url: "https://thepremiumbasket.com/",
  },
  {
    name: "The Trendy Store",
    pavilion: "Retail & Consumer Goods",
  },
  {
    name: "Tip Top",
    pavilion: "Retail & Consumer Goods",
  },
  {
    name: "Vanilla Bean",
    pavilion: "Food & Hospitality",
    blurb: "A home-based pastry business specialising in custom desserts and cakes, run by a certified pastry chef.",
  },
  {
    name: "Vela Healthcare and Wellness",
    pavilion: "Healthcare & Wellness",
  },
  {
    name: "WOLF",
    pavilion: "Real Estate & Construction",
  },
  {
    name: "Xcelacore AI",
    pavilion: "Technology & Innovation",
    blurb: "Xcelacore AI delivers enterprise-grade AI solutions, right-sized for the businesses that drive our economy.",
    logo: "exhibitor-xcelacore-ai.png",
    url: "https://xcelacore.com/",
  },
  {
    name: "Zahra's Kitchen",
    pavilion: "Food & Hospitality",
  },
  {
    name: "Zeez Bakeshop",
    pavilion: "Food & Hospitality",
  },
  {
    name: "ZS Global Enterprise",
    pavilion: "Real Estate & Construction",
    logo: "exhibitor-zs-global-enterprise.png",
    url: "https://zsglobalenterprise.com/",
  },
];

export default EXHIBITORS;
